export const experiences = [
  {
    company: 'University Center UTA',
    role: 'Student Assistant',
    period: 'Feb 2024 – Present',
    location: 'Arlington, TX',
    type: 'Part-time Student Position',
    highlights: [
      'Maintained and supported the event management software, ensuring accurate scheduling and reliable system operation.',
      'Assisted in implementing software-driven scheduling features, helping streamline event bookings for students and staff.',
      'Created basic dashboards and reports to monitor event schedules, room usage, and participation metrics.',
      'Collaborated with staff to improve digital workflows, reducing manual tracking and improving efficiency.',
      'Provided technical support and troubleshooting for users interacting with the platform.',
      'Coordinated 2,500+ campus events including AV equipment management, event logistics, and operational support.',
      'Supported 100+ daily visitors with inquiries, directions, and university resources while maintaining professional customer service standards.',
    ],
  },
  {
    company: 'BSO UTA',
    role: 'Full-Stack Developer (Founding Developer)',
    period: 'Aug 2025 – Present',
    location: 'Bangladeshi Student Organization, University of Texas at Arlington',
    type: 'Student Organization',
    highlights: [
      'Led the development of the organization\'s first digital platform, designing and implementing the full stack from concept to deployment.',
      'Built a Next.js community platform with role-based authentication (Admin/Student/Alumni) using NextAuth.js.',
      'Designed a Prisma database schema with 12+ models for events, payments, messaging, and member management.',
      'Integrated Stripe payments with webhooks for membership fees and donations.',
      'Developed an admin analytics dashboard with TypeScript + Tailwind CSS for real-time insights.',
      'Deployed and scaled the platform on Vercel with Neon PostgreSQL, supporting a growing student community.',
    ],
  },
  {
    company: 'Fintrion',
    role: 'Backend Engineer (Personal Project)',
    period: 'Jan 2024 – Jul 2025',
    location: 'Remote',
    type: 'Full-Stack Development',
    highlights: [
      'Designed PostgreSQL double-entry ledger schema with complex foreign key relationships for financial transactions.',
      'Built trading simulation engine with real-time data updates using React + Recharts visualization.',
      'Implemented Firebase Authentication with Prisma ORM for type-safe database queries.',
      'Architected event-driven system design (Redis-ready caching layer, WebSocket-ready for horizontal scaling).',
      'Created robo-advisory dashboard with portfolio rebalancing algorithms and tax optimization logic.',
    ],
  },
  {
    company: 'Axenyx',
    role: 'Full-Stack Engineer (Personal Project)',
    period: 'Jan 2025 – Oct 2025',
    location: 'Remote',
    type: 'Marketplace Platform',
    highlights: [
      'Developed a full-stack vehicle marketplace using Next.js 14, Prisma, and PostgreSQL with 10+ relational models.',
      'Integrated Stripe payment intents with webhook handling for secure escrow-style transactions.',
      'Implemented advanced search features with filtering, pagination, and full-text search using Prisma.',
      'Built real-time messaging UI with file upload support and threaded conversations for seamless user communication.',
      'Designed a scalable database schema supporting listings, users, messages, transactions, and role-based access control (RBAC).',
    ],
  },
];
